export const updateBubblingMask = (textValue, parentClassMask, fieldEl) => {
  const bubblingMask = fieldEl.querySelector(`${parentClassMask} #bubbling-mask`);

  if (textValue) {
    const words = textValue.split(' ');
    const regex = /@([^\s]+)@/;
    let newHTML = '';

    for (let i = 0; i < words.length; i++) {
      if (regex.test(words[i])) {
        const bubbleWord = words[i].match(regex)[1];
        const bubbleTag = words[i].match(regex)[0];
        const bubble = document.createElement('span');
        const leftAtSpan = document.createElement('span');
        const rightAtSpan = document.createElement('span');
        const tagIndex = words[i].indexOf(bubbleTag);
        const leftLeftOvers = words[i].substring(0, tagIndex);
        const rightLeftOvers = words[i].substring(leftLeftOvers.length + bubbleTag.length);

        leftAtSpan.className = 'bubbling-invisible-at';
        leftAtSpan.innerHTML = '@';

        rightAtSpan.className = 'bubbling-invisible-at';
        rightAtSpan.innerHTML = '@';

        bubble.className = 'bubbling-bubble';
        bubble.innerHTML = leftAtSpan.outerHTML
          + Monet.I18n.getResourcesByKey(`SelectKeyResource.${bubbleWord}`)
          + rightAtSpan.outerHTML;

        newHTML += `${leftLeftOvers}${bubble.outerHTML}${rightLeftOvers} `;
      } else {
        newHTML += `  ${words[i]}  `;
      }
    }
    bubblingMask.innerHTML = newHTML;
  } else {
    bubblingMask.innerHTML = '';
  }
};

const setListeners = (input, bubblingUnit, parentClass, fieldEl) => {
  const inputListeners = input;
  const bubblingUnitListeners = bubblingUnit;
  inputListeners.addEventListener('blur', () => {
    inputListeners.style.opacity = 0;
    inputListeners.style.zIndex = 0;
    bubblingUnitListeners.style.opacity = 1;
    updateBubblingMask(inputListeners.value, parentClass, fieldEl);
  });

  inputListeners.addEventListener('focus', () => {
    bubblingUnitListeners.style.opacity = 0;
    inputListeners.style.opacity = 1;
    inputListeners.style.zIndex = 999999;
    inputListeners.setSelectionRange(inputListeners.value.length, inputListeners.value.length);
  });

  bubblingUnitListeners.addEventListener('click', () => {
    inputListeners.focus();
  });
};

export default function prepareSelectAndAutocomplete(props) {
  const { changeAction, entity, name } = props;
  const parentClass = `#${props.entity} .field.addAttributeField.${props.name}`;

  const fieldEl = document.querySelector(`#${props.entity} .field.addAttributeField.${props.name}`);
  if (fieldEl) {
    const input = fieldEl.querySelector(`#${props.entity} .field.addAttributeField #${props.name}-${props.entity}`);
    const bubblingUnit = fieldEl.querySelector(`#${props.entity} #bubbling-mask.input-body_${props.name}`);
    const bubbleButton = fieldEl.querySelector(`#${props.entity} #bubble-button.input-body_${props.name}`);

    const autoComplete = new Greenmile.Components.AddAttribute.AutoComplete(fieldEl);
    const selectFieldList = new Greenmile.Components.AddAttribute.SelectFieldList();

    selectFieldList.addClickEventListener((field) => {
      if (field) {
        input.value += ` ${field.value}`;
        changeAction(entity, name, input.value);
        updateBubblingMask(input.value, parentClass, fieldEl);
      }
    });
    selectFieldList.setAvailableTags(autoComplete.loadAvailableTags(props.entitiesPropertiesList));
    selectFieldList.render();

    bubbleButton.appendChild(selectFieldList.elFieldList);

    if (input.value) {
      updateBubblingMask(input.value, parentClass, fieldEl);
    }

    setListeners(input, bubblingUnit, parentClass, fieldEl);
  }
}
